import React, { useState, useRef, useEffect, useMemo } from "react"
import { Card, CardBody, Col, Container, Row, DropdownToggle, DropdownItem, DropdownMenu, } from "reactstrap";
import { CascadeSelect } from 'primereact/cascadeselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Chips } from 'primereact/chips';
import { Checkbox } from 'primereact/checkbox';
import { MultiSelect } from 'primereact/multiselect';

import { Tooltip } from 'primereact/tooltip';
import { getCookie } from "../../helpers/cookie"
import axios from "axios";
import { useDispatch } from "react-redux";
import { SET_API_STATUS_FALSE, SET_API_STATUS_TRUE } from "../../store/calendar/actionTypes"
const NotesContact = () => {

    const token = getCookie('access_token');
    const dispatch = useDispatch();
    // link jobs 
    const [PrivetDropdownValues, setPrivetDropdownValues] = useState([]);
    const [contacts, setcontacts] = useState([]);
    const [selectedContact, setselectedContact] = useState(null);
    const [visibleLinkJob, setVisibleLinkJob] = useState(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const [valueNotes, setValueNotes] = useState(['John Doe']);
    const [popchecked, setPopchecked] = useState(false);

    // Private functionality state
    const [privateDrop, setPrivateDrop] = useState(false);
    const [PrivetDropdown, setPrivetDropdown] = useState([]);
    // const PrivetDropdownValues = [
    //     { name: 'Mahesh', value: 'mahesh' },
    //     { name: 'Lavan', value: 'lavan' },
    //     { name: 'Vinay', value: 'vinay' },
    //     { name: 'Vasantha', value: 'vasantha' }
    // ];

    const handlePopupCheckbox = e => {
        setPopchecked(e.checked)
    }

    const [candidateName, setCandidateName] = useState("Anupam Diridhar, John Doe, Amith, Sagar");
    const [currentDateTime, setCurrentDateTime] = useState(new Date());
    const [userId, setUserId] = useState("Anupam, John, Amith");
    const [subject, setSubject] = useState("");
    const [notes, setNotes] = useState("");

    const [selectedJobs, setSelectedJobs] = useState([]);
    const [jobs] = useState([
        { id: 1, title: 'Mahesh Kumar Boga, UI/UX Manager', contact: 'mahesh@varundigitalmedia.com' },
        { id: 2, title: 'Salmanuddin, Sales Manager', contact: 'salman@varundigitalmedia.com' },
        { id: 3, title: 'Suresh Reddy, SEO Manager', contact: 'suresh@varundigitalmedia.com' },
        { id: 4, title: 'Aman Kumar, AIML Lead', contact: 'aman@varundigitalmedia.com' },
        { id: 5, title: 'Giri Jalagam, Hr Recruiter', contact: 'giri@varundigitalmedia.com' },
    ]);

    const [searchText, setSearchText] = useState('');
    const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
    const [selectedJobTitles, setSelectedJobTitles] = useState('');

    const handleIconClick = () => {
        setJobDetailsVisible(true);
    };

    const handleSave = () => {
        const selectedJobTitles = selectedJobs.map((job) => job.title).join(', ');
        setSelectedJobTitles(selectedJobTitles);
        setJobDetailsVisible(false);
    };

    const handleRefresh = () => {
        setSelectedJobs([]);
        setSearchText('');
    };

    const filteredJobs = jobs.filter(
        (job) =>
            job.title.toLowerCase().includes(searchText.toLowerCase()) ||
            job.contact.toLowerCase().includes(searchText.toLowerCase()) ||
            job.id.toString().includes(searchText)
    );

    const getPrivateOptions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/private-users/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        let results = response.data.data;
        console.log(results, 'results');
        const options = results.map((category) => ({
          name: category.name
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase()),
          code: category.id,
          email: category.email,
        }));
        setPrivetDropdownValues(options);
      }
    } catch (error) {

    }
  };
    // link jobs 
    const getWorktypes = async () => {

        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/contacts/?is_archived=false`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                setcontacts(response.data.results);
            }
        } catch (err) {
            console.log(err);
        }
    }
    useEffect(() => {
        getWorktypes();
        getPrivateOptions();
    }, []);
    const handleNotesAdd = async () => {
        const notesData = {
            "type": "Note",
            "content": notes,
            is_important: true,
            is_private: popchecked,
            private_users: privateDrop,
        };
        const response = await axios.post(
            `${process.env.REACT_APP_Company_Contact}/company/contacts/${selectedContact}/notes/`,
            notesData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (response.status === 201) {
            setNotes("")
            setVisibleLinkJob(false)
            dispatch({ type: SET_API_STATUS_TRUE })
            setTimeout(() => {
                dispatch({ type: SET_API_STATUS_FALSE })
            }, 2000)
        }
    }

    return (
        <React.Fragment>

            <Tooltip target=".notes" content="Contacts Notes" position="bottom" style={{ marginTop: "5px" }} />

            <button
                type="button"
                className="btn btn-secondary icons-btn me-1 notes"
                //  onClick: () => setVisibleLinkJob(true)
                onClick={() => setVisibleLinkJob(true)}
            >
                <i class="pi pi-file"></i>
            </button>

            <Dialog header={`Note - ${selectedJobTitles}`} visible={visibleLinkJob} onHide={() => setVisibleLinkJob(false)}
                style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} className="link-candidates">
                <Row>
                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="candidate" className="block mb-0">
                                Type
                            </label>
                            <InputText
                                id="candidate"
                                value="Note"
                                readOnly
                                className="w-full"
                                placeholder="Note"
                                disabled
                            />
                        </div>
                    </Col>


                    <Col lg={6}>
                        <div className="field">
                            <label htmlFor="currentDateTime" className="block mb-0">
                                Date
                            </label>
                            <Calendar
                                id="currentDateTime"
                                value={currentDateTime}
                                onChange={(e) => setCurrentDateTime(e.value)} // Update state on change
                                showTime
                                showIcon
                                dateFormat="dd/mm/yy" // Customize the date format
                                hourFormat="12" // Use 12-hour time format (or "12" for AM/PM)
                                readOnlyInput
                                className="w-full"
                            />
                        </div>
                    </Col>

                    {/* <Col lg={12}>
                        <div className="field">
                            <label htmlFor="candidate" className="block mb-0">
                                Candidates
                            </label>
                            <InputText
                                id="candidate"
                                value={candidateName}
                                readOnly
                                className="w-full"
                                disabled
                            />
                        </div>
                    </Col> */}

                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="job" className="block mb-0">Contact</label>
                            <Dropdown
                                id="project"
                                value={selectedContact}
                                onChange={(e) => setselectedContact(e.value)}
                                options={contacts}
                                placeholder="Select Contact"
                                className="w-full bgclr"
                                optionLabel={(option) => `${option.first_name} ${option.last_name} - ${option.email}`}
                                optionValue="id"
                                filter
                            />
                            <Dialog
                                header="Contact Details"
                                visible={jobDetailsVisible}
                                onHide={() => setJobDetailsVisible(false)}
                                style={{ width: '40vw' }}
                                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                                className="cand-details"
                            >
                                {/* Search Bar */}
                                <Row>
                                    <Col lg={12}>
                                        <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                            <InputText
                                                placeholder="Search Jobs"
                                                value={searchText}
                                                onInput={(e) => setSearchText(e.target.value)}
                                                style={{ paddingRight: '2rem' }} // Space for the icon
                                            />
                                            <i
                                                className="pi pi-search"
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '49%',
                                                    transform: 'translateY(-50%)',
                                                }}
                                            ></i>
                                        </div>
                                    </Col>
                                </Row>

                                {/* DataTable */}
                                <DataTable
                                    value={filteredJobs}
                                    paginator
                                    rows={5}
                                    selection={selectedJobs}
                                    onSelectionChange={(e) => setSelectedJobs(e.value)}
                                    dataKey="id"
                                    rowsPerPageOptions={[5, 10, 25]}
                                    size="small" // Set size to small
                                >
                                    <Column selectionMode="multiple" style={{ width: '3em' }} />
                                    <Column field="id" header="Contact ID" />
                                    <Column field="title" header="Contact Title" />
                                    <Column field="contact" header="Contact" />
                                </DataTable>

                                {/* Actions */}
                                <div className="d-flex  mt-3">
                                    {/* <Button label="Save" icon="pi pi-save" onClick={handleSave} />
                                                    <Button label="Refresh" icon="pi pi-refresh" onClick={handleRefresh} className="p-button-secondary" /> */}
                                    <button type="button" class="btn btn-primary me-2 btn-main" onClick={handleSave}>Save</button>
                                    <button type="button" class="btn btn-primary btn-main" onClick={handleRefresh}>Refresh</button>
                                </div>
                            </Dialog>
                        </div>
                    </Col>
                </Row>
                <Row>
                    {/* <Col lg={6}>
                        <div className="field">
                            <label htmlFor="currentDateTime" className="block mb-0">
                                Date
                            </label>
                            <Calendar
                                id="currentDateTime"
                                value={currentDateTime}
                                onChange={(e) => setCurrentDateTime(e.value)} // Update state on change
                                showTime
                                showIcon
                                dateFormat="dd/mm/yy" // Customize the date format
                                hourFormat="12" // Use 12-hour time format (or "12" for AM/PM)
                                readOnlyInput
                                className="w-full"
                            />
                        </div>
                    </Col> */}

                    <Col lg={12}>
                        <div className="field">
                            <label htmlFor="notes" className="block mb-0">
                                Notes
                            </label>
                            <InputTextarea
                                id="notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)} // Update the state on input change
                                rows={3} // Number of visible rows
                                cols={20} // Number of visible columns
                                className="w-full"
                                placeholder="Enter your notes here..."
                                autoResize // Automatically adjusts height as content grows
                            />
                        </div>
                    </Col>

                </Row>
                <Row className="align-items-center">
                    <Col lg={2}>
                        <div className="d-flex align-items-center">
                            <Checkbox
                                inputId="privateCheckbox"
                                checked={privateDrop}
                                onChange={(e) => setPrivateDrop(e.checked)}
                            />
                            <label htmlFor="privateCheckbox" className="ms-2 mt-2">
                                Private
                            </label>
                        </div>
                    </Col>
                    <Col lg={6}>
                        {privateDrop && (
                            <div className="field notes-chip">
                                <label htmlFor="userId" className="block mb-0">
                                    User IDs
                                </label>
                                <MultiSelect
                                    value={PrivetDropdown}
                                    onChange={(e) => setPrivetDropdown(e.value)}
                                    options={PrivetDropdownValues}
                                    optionLabel={(option) => `${option.name} (${option.email})`}
                                    optionValue="code"
                                    // optionLabel="name"
                                    display="comma"
                                    placeholder="Select User Id's"
                                    maxSelectedLabels={10}
                                    className="w-full"
                                />
                            </div>
                        )}
                    </Col>




                </Row>

                <Row>

                    <Col lg={12}>
                        <div className="d-flex justify-content-end">
                            <button type="button" class="btn btn-primary me-2 btn-main" onClick={handleNotesAdd}>Add Note</button>
                        </div>
                    </Col>
                </Row>


            </Dialog>


        </React.Fragment>
    );
};



export default NotesContact;
